/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-evaluate': {
    width: 43,
    height: 38,
    viewBox: '0 0 43 38',
    data: '<path pid="0" d="M38.345 4.145C33.608-.512 25.98-.673 21.001 3.744 16.023-.673 8.395-.512 3.657 4.145-1.16 8.963-1.24 16.832 3.577 21.73l.16.16 14.454 14.454c1.526 1.526 4.015 1.606 5.62.08l.08-.08 14.454-14.453c4.818-4.818 4.898-12.687.16-17.505-.08-.16-.08-.16-.16-.24z" _fill="#FFBD2E"/>'
  }
})
